export default "__VITE_PUBLIC_ASSET__37126ece__"